import { render, staticRenderFns } from "./coachClassesList.vue?vue&type=template&id=c39a1b3c&scoped=true"
import script from "./coachClassesList.vue?vue&type=script&lang=js"
export * from "./coachClassesList.vue?vue&type=script&lang=js"
import style0 from "./coachClassesList.vue?vue&type=style&index=0&id=c39a1b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39a1b3c",
  null
  
)

export default component.exports